export default __webpack_public_path__ + "static/media/585_5.9ef51232.jpg";